const modules = require.context('./', true, /\.vue$/);
export default Vue => {
  modules.keys().forEach((key) => {
    const component = modules(key).default || null;
    if (!component) return null;
    Vue.component(component.name, component);
  });
};
